import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { ToastrService } from "ngx-toastr";
// import axios from 'axios';
function _window(): any {
  // return the global native browser window object
  return window;
}
@Injectable({
  providedIn: "root",
})
export class PatientService {
  baseUrl = environment.UserURL;
  AdminUrl = environment.AdminURL;
  AuthUrl = environment.AuthURL;
  // AuthUrl = "https://6b0c-103-15-67-130.ngrok-free.app"

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastrService: ToastrService
  ) {}
  get nativeWindow(): any {
    return _window();
  }
  pincode(Pincode) {
    return this.http.get(
      `${this.baseUrl}/v0.1/city/getCity?Pincode=${Pincode}`
    );
  }

  //API FOR UPDATE AYUHEALTH STATUS
  postAyuHelatApi(data) {
    // debugger;
    return this.http.post(
      `https://lro1h4dk0d.execute-api.ap-south-1.amazonaws.com/test/digisparsh`,
      data // PROD
      // `https://lro1h4dk0d.execute-api.ap-south-1.amazonaws.com/test/digisparsh_test`, data // UAT
    );
  }

  editCliamInvoiceByAdmin(post) {
    return this.http.get(`${this.baseUrl}/api/aggregator/getCurrentUser`, post);
  }
  getFacetValidatedHospitalToAggregator() {
    return this.http.get(
      `${this.baseUrl}/api/Invoice/getFacetValidatedHospitalToAggregator`
    );
  }
  getProductByOrg() {
    return this.http.get(`${this.baseUrl}/api/patient/getProductByOrg`);
  }
  getFacetDApprovedHospitalToAggregator() {
    return this.http.get(
      `${this.baseUrl}/api/Invoice/getFacetDApprovedHospitalToAggregator`
    );
  }
  getFacetLApprovedHospitalToAggregator() {
    return this.http.get(
      `${this.baseUrl}/api/Invoice/getFacetLApprovedHospitalToAggregator`
    );
  }
  getLoanByKoCode(KOCode) {
    return this.http.get(
      `${this.baseUrl}/v0.1/loan/getLoanByKoCode?KoCode=${KOCode}`
    );
  }
  currentUser() {
    return this.http.get(`${this.baseUrl}/api/aggregator/getCurrentUser`);
  }
  currentUser1(post) {
    return this.http.get(`${this.baseUrl}/api/aggregator/getCurrentUser`, post);
  }
  // getAllInvoices(post) {
  //
  //   return this.http.post(`${this.baseUrl}/api/patient/getAllInvoices`, post);
  // }

  getAllInvoices(post?) {
    if (post) {
      return this.http.get(
        `${this.baseUrl}/api/patient/getAllInvoices?${post}`
      );
    } else {
      return this.http.get(`${this.baseUrl}/api/patient/getAllInvoices`);
    }
  }

  /////////////////////////////lender invoice list//////////
  getAllInvoicesForLender(post?) {
    if (post) {
      return this.http.get(
        `${this.baseUrl}/api/patient/Lender/getAllInvoices?${post}`
      );
    } else {
      return this.http.get(`${this.baseUrl}/api/patient/Lender/getAllInvoices`);
    }
  }

  getAllOrg(post?) {
    if (post) {
      return this.http.get(
        `${this.baseUrl}/api/patient/Lender/getAllOrg${post}`
      );
    } else {
      return this.http.get(`${this.baseUrl}/api/patient/Lender/getAllOrg`);
    }
  }
  getPatientList(post?) {
    if (post) {
      return this.http.get(`${this.AuthUrl}/api/bima/getPatientList${post}`);
    } else {
      return this.http.get(`${this.AuthUrl}/api/bima/getPatientList`);
    }
  }

  updateDisbursementByExcel(post) {
    return this.http.post(
      `${this.baseUrl}/api/patient/Lender/updateDisbursementByExcel`,
      post
    );
  }

  updatePatientInvoiceByExcel(post) {
    return this.http.post(
      `${this.baseUrl}/api/patient/Lender/updatePatientInvoiceByExcel`,
      post
    );
  }

  //////api/patient/Lender/updateDisbursementByExcel
  postpatientsLoan(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/postpatientsLoan`,
      post
    );
  }

  PostPatientTermLoan(post) {
    // debugger;
    return this.http.post(
      `${this.baseUrl}/api/patient/postPatientTermLoan`,
      post
    );
  }
  getLocation(term: number): Promise<any> {
    return this.http
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${term}&key=AIzaSyCHjOVqC7VgEqq9c8pfIfdfoLe9iRf5cPI`
      )
      .toPromise()
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.resolve(error.json()));
  }
  // getpincode(pincode){
  //  let  headers = new HttpHeaders();
  //   headers.set('authorization', '');
  //   let url=`https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=AIzaSyDMJEdj0gm0HP2XbUMG2jJ5y-m-Tw2Ca-U`
  //   return this.http.get(url);
  // }
  getpincode(pincode) {
    return this.http.get(
      `${this.baseUrl}/api/patient/getAddressByPIN?pincode=${pincode}`
    );
  }
  editInvoice(post, id) {
    return this.http.post(
      `${this.baseUrl}/api/patient/editInvoice?_id=${id}`,
      post
    );
  }

  getInvoiceById(id) {
    return this.http.get(
      `${this.baseUrl}/api/patient/getInvoiceById?_id=${id}`
    );
  }

  updatePatientInvoiceForUser(post) {
    return this.http.put(
      `${this.baseUrl}/api/patient/updatePatientInvoice`,
      post
    );
  }

  updateRecommendedAmount(post) {
    return this.http.put(
      `${this.baseUrl}/api/patient/updatePatientInvoice1`,
      post
    );
  }
  /////////////get Invoice By Id For Lender///////////////////////
  getInvoiceByIdForLender(id) {
    return this.http.get(
      `${this.baseUrl}/api/patient/Lender/getInvoiceById?_id=${id}`
    );
  }

  updatePatientInvoice(data) {
    return this.http.put(
      `${this.baseUrl}/api/patient/Lender/updatePatientInvoice`,
      data
    );
  }

  updateDisbursement(data) {
    return this.http.put(
      `${this.baseUrl}/api/patient/lender/updateDisbursement`,
      data
    );
  }

  updateSettlement(data) {
    return this.http.post(`${this.baseUrl}/api/patient/updateSettlement`, data);
  }

  /////api/patient/updateSettlement

  createMandateForm(_id) {
    return this.http.get(
      `${this.baseUrl}/api/patient/createMandateForm?_id=${_id}`
    );
  }

  updateMandateStatus(_id, digioResponse) {
    return this.http.put(
      `${this.baseUrl}/api/patient/updateMandateStatus?_id=${_id}`,
      digioResponse
    );
  }

  verifyDocumentByUser(data) {
    return this.http.post(`${this.baseUrl}/api/patient/eSignAgreement`, data);
  }

  // file uploader API's
  getauthtoken() {
    return this.http.get(`${this.baseUrl}/auth`);
  }
  uploadDocuments2(post) {
    return this.http.post(
      `https://upload.imagekit.io/api/v1/files/upload`,
      post
    );
  }
  uploadPANDoc(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/uploadPANDoc`,
      post
    );
  }
  uploadAadharDoc(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/uploadAadharDoc`,
      post
    );
  }

  uploadCancelledCheque(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/uploadCancelledCheque`,
      post
    );
  }

  InsurancepolicyDoc(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/InsurancepolicyDoc`,
      post
    );
  }

  FinalBilluploadDoc(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/FinalBilluploadDoc`,
      post
    );
  }

  //NACH and Agreement file uploader
  uploadDoc(post) {
    return this.http.post(`${this.baseUrl}/v0.1/patientloan/uploadDoc`, post);
  }

  ProofuploadDoc(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/ProofuploadDoc`,
      post
    );
  }

  uploadIncomeDoc(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/uploadIncomeDoc`,
      post
    );
  }

  bankStatementDoc(post) {
    return this.http.post(
      `${this.baseUrl}/v0.1/patientloan/bankStatementDoc`,
      post
    );
  }

  uploadexcel(data) {
    return this.http.post(
      `${this.baseUrl}/v0.1/loan/dataUploadByExcelLoanApprove`,
      data
    );
  }

  uploadFinalBill(post) {
    return this.http.post(`${this.baseUrl}/api/patient/uploadFinalBill`, post);
  }

  // All in one API Patient Dashboard

  getPdash() {
    return this.http.get(`${this.baseUrl}/api/patientloan/getpdash`);
  }

  getAlldata1() {
    return this.http.get(`${this.baseUrl}/api/patient/getPractoDashboard`);
  }

  getAlldata(dateTo, dateFrom) {
    return this.http.get(
      `${this.baseUrl}/api/patient/getPractoDashboard?dateTo=${dateTo}&dateFrom=${dateFrom}`
    );
  }
  ////////Patient Lender Dashboard//////////////////////////
  getDashboard() {
    return this.http.get(`${this.baseUrl}/api/patient/Lender/getDashboard`);
  }

  getDashboard1(dateTo, dateFrom) {
    return this.http.get(
      `${this.baseUrl}/api/patient/Lender/getDashboard?dateTo=${dateTo}&dateFrom=${dateFrom}`
    );
  }

  /////new patient term loan///////

  // getPdash(){

  //   return this.http.get(`${this.baseUrl}/api/patientloan/getpdash`);
  // }

  patientLoanDashJob() {
    return this.http.get(`${this.AdminUrl}/api/patientDash/patientLoanDashJob`);
  }

  patientLoanDashJob1(dateTo, dateFrom) {
    return this.http.get(
      `${this.AdminUrl}/api/patientDash/patientLoanDashJob?dateTo=${dateTo}&dateFrom=${dateFrom}`
    );
  }
  getByIdToLender() {
    return this.http.get(`${this.baseUrl}/api/lender/getByIdToLender`);
  }
  // getAlldata(dateTo,dateFrom) {
  //   return this.http.get(`${this.baseUrl}/api/patient/getPractoDashboard?dateTo=${dateTo}&dateFrom=${dateFrom}`);
  // }

  // BG Api

  // check_patient(data){
  //   return this.http.get(`${this.AuthUrl}/api/bima/check-patient?mobileNumber=${data}`)
  // }
  check_patient(post?) {
    if (post) {
      return this.http.get(`${this.AuthUrl}/api/bima/check-patient${post}`);
    } else {
      return this.http.get(`${this.AuthUrl}/api/bima/check-patient`);
    }
  }
  tpa() {
    return this.http.get(`${this.AuthUrl}/api/bima/tpa`);
  }
  insuranceco() {
    return this.http.get(`${this.AuthUrl}/api/bima/insuranceco`);
  }
  downloadConsentLetter() {
    return this.http.get(`${this.baseUrl}/api/patient/downloadConsentLetter`);
  }
  CreateBimaPatient(post) {
    return this.http.post(`${this.AuthUrl}/api/bima/CreatePatient`, post);
  }
  UpdateClaimStage1(post, id) {
    return this.http.patch(
      `${this.AuthUrl}/api/bima/UpdateClaimStage1?PatientId=${id}`,
      post
    );
  }
  UpdateClaimStage2(post, id) {
    return this.http.patch(
      `${this.AuthUrl}/api/bima/UpdateClaimStage2?PatientId=${id}`,
      post
    );
  }
  UpdateClaimStage3(post, id) {
    return this.http.patch(
      `${this.AuthUrl}/api/bima/UpdateClaimStage3?PatientId=${id}`,
      post
    );
  }
  UpdateClaimStage4(post, id) {
    return this.http.patch(
      `${this.AuthUrl}/api/bima/UpdateClaimStage4?PatientId=${id}`,
      post
    );
  }
  UpdateClaimStage5(post, id) {
    return this.http.patch(
      `${this.AuthUrl}/api/bima/UpdateClaimStage5?PatientId=${id}`,
      post
    );
  }
  UpdateDisbersment(post, id) {
    return this.http.patch(
      `${this.AuthUrl}/api/bima/UpdateDisbersment?CaseId=${id}`,
      post
    );
  }
  upload_document(post) {
    return this.http.post(`${this.AuthUrl}/api/bima/upload_document`, post);
  }
  UpdateClaimStage6(post, id) {
    return this.http.patch(
      `${this.AuthUrl}/api/bima/UpdateClaimStage6?PatientId=${id}`,
      post
    );
  }
  ClaimReject(post, id) {
    // return null
    return this.http.patch(
      `${this.AuthUrl}/api/bima/CaseReject?PatientId=${id}`,
      post
    );
  }
  queryPending(post, id) {
    // return null
    return this.http.patch(
      `${this.AuthUrl}/api/bima/queryPending?caseid=${id}`,
      post
    );
  }
  editCase(post) {
    // return null
    return this.http.patch(`${this.AuthUrl}/api/bima/editCase`, post);
  }
  caseById(id) {
    return this.http.get(`${this.AuthUrl}/api/bima/getCaseById?case_id=${id}`);
  }

  getbimatoken() {
    return this.http.get(`${this.AuthUrl}/api/bima/token`);
  }
  createBimapatient(post) {
    return this.http.post(
      `https://deskqa2.bimagarage.com/external/api/create-patient/`,
      post
    );
  }

  /////////////////////////////
  showToaster(message) {
    this.toastrService.success(message);
  }
  ErrorSuccess(message) {
    this.toastrService.error(message);
  }
  infoSuccess(message) {
    this.toastrService.info(message);
  }
  warningSuccess(message) {
    this.toastrService.warning(message);
  }

  CreateCase(post) {
    return this.http.post(`${this.AuthUrl}/api/bima/createCase`, post);
  }
  caseList(id, data) {
    return this.http.get(`${this.AuthUrl}/api/bima/getCaseList?id=${id}`, data);
  }
  getmobilenumber(mobileNumber) {
    return this.http.get(
      `${this.AuthUrl}/api/bima/getPatientDetailsByMobileNumber?MobileNumber=${mobileNumber}`
    );
  }

  getAllBanks() {
    return this.http.get(`${this.baseUrl}/api/patient/getAllBanks`);
  }
  getOrgByIdToAdmin(id) {
    return this.http.get(`${this.baseUrl}/api/patient/getOrgById?_id=${id}`);
  }
  // API for getting all details of hospitals
  getHospitaList() {
    // debugger;
    return this.http.get(`${this.AuthUrl}/api/excel/getAllHospitalBankDetails`);
  }

  // PATNER STATUS --> DOCUMENT URL (STATUS -> )
  getPartnerDoc(ID) {
    return this.http.get(
      `${this.baseUrl}/api/patient/getAgreementPdf?_id=${ID}`
    );
  }

  getPartnerDoc1(ID) {
    // debugger;
    return this.http.get(
      `${this.baseUrl}/api/patient/sendAgreementPdf?_id=${ID}`
    );
  }

  checkBankDetailS(data) {
    return this.http.post(
      `${this.baseUrl}/api/patient/createMandateForm`,
      data
    );
  }
}
